var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-button',_vm._g(_vm._b({},'t-button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('div',{staticClass:"animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white m-auto"}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }